<div [formGroup]="payoneCreditCardForm">
  <!-- This element is used by Payone scripts for error handling. -->
  <p class="text-danger col-sm-offset-4" id="error"></p>
  <p *ngIf="generalErrorMessage" class="text-danger col-sm-offset-4">
    {{ generalErrorMessage | translate }}
  </p>
  <!-- card number -->
  <div class="row form-group">
    <label class="col-form-label col-md-4" for="cardpanInput"
      >{{ 'checkout.credit_card.number.label' | translate }}<span class="required" aria-hidden="true">*</span></label
    >
    <div class="col-sm-6">
      <span id="cardpan" class="inputIframe"></span>
    </div>
  </div>

  <!-- card type -->
  <div class="row form-group">
    <label class="col-form-label col-md-4" for="cardtype"
      >{{ 'checkout.credit_card.type.label' | translate }}<span class="required" aria-hidden="true">*</span></label
    >
    <div class="col-sm-6">
      <span id="cardtype" class="inputIframe"></span>
    </div>
  </div>

  <!-- expiry date -->
  <div class="row form-group">
    <label class="col-form-label col-md-4" for="expireInput"
      >{{ 'checkout.credit_card.expiration_date.label' | translate
      }}<span class="required" aria-hidden="true">*</span></label
    >
    <div class="col-sm-6">
      <span id="expireInput" class="inputIframe">
        <span id="cardexpiremonth"></span>&nbsp;<span id="cardexpireyear"></span>
      </span>
    </div>
  </div>

  <!-- security code CVC -->
  <div *ngIf="isSecurityCodeCheckRequired()" class="row form-group">
    <label class="col-form-label col-md-4" for="cvcInput"
      >{{ 'checkout.credit_card.cvc.label' | translate }}<span class="required" aria-hidden="true">*</span></label
    >
    <div class="col-sm-6">
      <span id="cardcvc2" class="inputIframe"></span>
    </div>
  </div>
</div>

<ish-payment-save-checkbox *ngIf="paymentMethod" [paymentMethod]="paymentMethod" [form]="payoneCreditCardForm" />

<div class="row">
  <div class="offset-md-4 col-md-8">
    <button type="button" (click)="submitNewPaymentInstrument()" class="btn btn-primary">
      {{ 'checkout.account.submit.button.label' | translate }}
    </button>
    <button type="button" class="btn btn-secondary" (click)="cancelNewPaymentInstrument()">
      {{ 'checkout.cancel.button.label' | translate }}
    </button>
  </div>
</div>
